import { render, staticRenderFns } from "./GenericVArraySchema.vue?vue&type=template&id=48d61ee2&scoped=true&"
import script from "./GenericVArraySchema.vue?vue&type=script&lang=js&"
export * from "./GenericVArraySchema.vue?vue&type=script&lang=js&"
import style0 from "./GenericVArraySchema.vue?vue&type=style&index=0&id=48d61ee2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d61ee2",
  null
  
)

export default component.exports